var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.66699L12.5869 10.3504C12.4813 12.0579 12.4285 12.9117 12.0005 13.5256C11.7889 13.8291 11.5165 14.0852 11.2005 14.2777C10.5614 14.667 9.706 14.667 7.99513 14.667C6.28208 14.667 5.42553 14.667 4.78603 14.2769C4.46987 14.0841 4.19733 13.8275 3.98579 13.5235C3.55792 12.9087 3.5063 12.0537 3.40307 10.3438L3 3.66699",
    stroke: "#FF3B30",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.66634H14M10.7038 3.66634L10.2487 2.72749C9.9464 2.10385 9.7952 1.79202 9.53447 1.59755C9.47667 1.55441 9.4154 1.51603 9.35133 1.48281C9.0626 1.33301 8.71607 1.33301 8.023 1.33301C7.31253 1.33301 6.95733 1.33301 6.66379 1.48909C6.59873 1.52368 6.53665 1.56361 6.47819 1.60845C6.21443 1.81081 6.06709 2.13404 5.77241 2.78051L5.36861 3.66634",
    stroke: "#FF3B30",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33301 11V7",
    stroke: "#FF3B30",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66699 11V7",
    stroke: "#FF3B30",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.26998aeec7b0c6d50a0788034a90af12.svg";
export { ForwardRef as ReactComponent };